import React, { useState } from 'react';
import { getNumberMessageReport } from '../../../lib/api';
import { ERROR_CODE_MESSAGES } from '../../../constants/errorCodeMessages';
import './summary.css';
import './detailsReport.css';

const NumberSearch = () => {
  const [phone, setPhone] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total_pages: 1 });

  const fetchData = async (p=1) => {
    setLoading(true); setError('');
    try {
      const body = { phone_number: phone };
      const resp = await getNumberMessageReport(body, p, 10);
      setData(resp.data || []);
      setPagination(resp.pagination || { total_pages: 1 });
      setPage(p);
    } catch (e) {
      setError(e?.message || 'Failed to fetch');
    } finally { setLoading(false); }
  };

  const onSearch = () => fetchData(1);

  const renderChatPreview = (messageBodyJson, templateCodeJson) => {
    if (!messageBodyJson || !templateCodeJson) {
      return <div className="chat-bubble error">Template or data missing</div>;
    }
    try {
      const messageData = typeof messageBodyJson === 'string' ? JSON.parse(messageBodyJson) : messageBodyJson;
      const templateCode = typeof templateCodeJson === 'string' ? JSON.parse(templateCodeJson) : templateCodeJson;
      const headerText = templateCode?.components?.find((c) => c.type === 'HEADER')?.text || '';
      const footerText = templateCode?.components?.find((c) => c.type === 'FOOTER')?.text || '';
      const bodyTemplate = templateCode?.components?.find((c) => c.type === 'BODY')?.text || '';
      const params = messageData?.template?.components?.find((c) => c.type === 'BODY')?.parameters || [];
      let filledBody = bodyTemplate;
      params.forEach((param, idx) => {
        const placeholder = `{{${idx + 1}}}`;
        filledBody = filledBody.replace(placeholder, param?.text || '');
      });
      return (
        <div className="chat-bubble">
          {headerText && <div className="chat-header">{headerText}</div>}
          <div className="chat-body">{filledBody}</div>
          {footerText && <div className="chat-footer">{footerText}</div>}
        </div>
      );
    } catch (e) {
      return <div className="chat-bubble error">Invalid JSON</div>;
    }
  };

  const parseError = (row) => {
    if (row.status !== 'failed' || !row.errors) return '-';
    try {
      const parsed = typeof row.errors === 'string' ? JSON.parse(row.errors) : row.errors;
      const first = Array.isArray(parsed) ? parsed[0] : parsed;
      const code = first?.code;
      return ERROR_CODE_MESSAGES[code] || first?.message || 'Unknown error';
    } catch {
      return 'Invalid error format';
    }
  };

  return (
    <div className="summary-wrap">
      <div className="summary-header">
        <h2>Number Message Report</h2>
        <div className="summary-meta">{data.length} results</div>
      </div>

      <div className="filter-bar" style={{ gridTemplateColumns: '1fr auto' }}>
        <div className="field">
          <label>Phone</label>
          <input className="filt-control" type="text" value={phone} onChange={(e)=>setPhone(e.target.value)} placeholder="e.g. 98xxxxxx" />
        </div>
        <div className="actions">
          <button className="btn btn-primary" onClick={onSearch}>Search</button>
        </div>
      </div>

      {error && <div className="error" style={{ marginBottom: 8 }}>{error}</div>}

      <div className="summary-scroll">
        <div className="summary-table-wrap">
          <table className="summary-table">
            <thead>
              <tr>
                <th>Campaign ID</th>
                <th>Template Name</th>
                <th>Status</th>
                <th>Sent At</th>
                <th>Updated At</th>
                <th>Chat Preview</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({length:8}).map((_,i)=> (
                  <tr key={`sk-${i}`} className="skeleton-row">
                    <td><div className="sk sk-text" /></td>
                    <td><div className="sk sk-text long" /></td>
                    <td><div className="sk sk-pill" /></td>
                    <td><div className="sk sk-text" /></td>
                    <td><div className="sk sk-text" /></td>
                    <td><div className="sk sk-bubble" /></td>
                    <td><div className="sk sk-text long" /></td>
                  </tr>
                ))
              ) : (
                data.length ? data.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.campaign_id}</td>
                    <td>{row.wa_template_name || row.template_name || '—'}</td>
                    <td>{row.status}</td>
                    <td>{(row.sent_at || row.message_sent_at) ? new Date(row.sent_at || row.message_sent_at).toLocaleString() : '—'}</td>
                    <td>{(row.updated_at || row.message_updated_at) ? new Date(row.updated_at || row.message_updated_at).toLocaleString() : '—'}</td>
                    <td>{renderChatPreview(row.message_body, row.wa_template_code)}</td>
                    <td>{parseError(row)}</td>
                  </tr>
                )) : <tr><td colSpan={7} className="empty-cell">No results</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {!loading && data.length > 0 && (
          <div className="pagination-controls">
            <button disabled={page===1} onClick={()=>fetchData(page-1)}>Previous</button>
            <span>Page {page} of {pagination.total_pages}</span>
            <button disabled={page>=pagination.total_pages} onClick={()=>fetchData(page+1)}>Next</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NumberSearch;
